// Initialise Sentry first so it can capture any errors thrown by later modules.
require('../shared/js/sentry.js');

require('./dependencies.js');
require('./main.scss');

// Require all js files in /js
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./js/', true, /\.js$/));

// Require shared files in ../shared/js/
requireAll(require.context('../shared/js/', true, /\.js$/));